import React, { useState } from "react"
import MediaUploadModal from "./MediaUploadModal.js";
import StoryboardPanelsContainer from "./StoryboardPanelsContainer.js";
import FileUploadButton from "../../user-files/FileUploadButton.js";
import allowedStoryboardFileTypes from "../allowedStoryboardFileTypes.js";
import { FormattedMessage } from "react-intl";
import { WingsDetailText, WingsHeading } from "@wingspans-ui";
import "./Storyboard.css"

/**
 * The private/editable view of the current user's storyboard section
 */
const Storyboard = () => {
  const [newFiles, setNewFiles] = useState([])

  return (
    <div className="storyboard">
      <div className="upload-button-container">
        <WingsHeading level={5} className="title">
          <FormattedMessage
            id="storyboard"
            defaultMessage="Storyboard"
          />
        </WingsHeading>
        <div className="w-mb-1">
          <WingsDetailText>
            <FormattedMessage
              id="storyboard-instructions"
              defaultMessage="Upload images, videos, and documents that represent your projects."
            />
          </WingsDetailText>
        </div>
        <FileUploadButton 
          processFiles={(files) => setNewFiles(files)}
          allowedTypes={allowedStoryboardFileTypes}
          id="storyboard"
        />
      </div>
      <StoryboardPanelsContainer/>
      <MediaUploadModal 
        isOpen={newFiles.length > 0} 
        handleClose={() => setNewFiles([])}
        newFiles={newFiles}
      />
    </div>
  )
}

export default Storyboard
